import { useEffect } from 'react';

/**
 * Generic Material Design 3 bottom sheet: scrim + sliding panel with a
 * fixed header and fixed footer, and a scrollable body in between.
 * Used by EventFormSheet and TemplateEditorSheet so both share exactly
 * the same open/close animation and layout as the original mockup.
 */
export default function BottomSheet({ open, onClose, title, children, footer }) {
  // Prevent background scroll while a sheet is open (mobile Safari
  // in particular needs this in addition to overflow:hidden on body).
  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [open]);

  return (
    <>
      <div className={`scrim${open ? ' show' : ''}`} onClick={onClose} />
      <div className={`sheet${open ? ' show' : ''}`}>
        <div className="sheet-handle" />
        <div className="sheet-head">
          <h2>{title}</h2>
          <button className="close-btn" onClick={onClose} type="button">
            ✕
          </button>
        </div>
        <div className="sheet-body">{children}</div>
        {footer && <div className="sheet-footer">{footer}</div>}
      </div>
    </>
  );
}
